import { AlertMessage } from 'components/notification/AlertMessage';
import { func_validation } from 'functions';
import React, { useEffect, useState } from 'react';

export function useAlertMessage(props) {
    const {
        addAccount_errorMsg,
        deleteAccount_errorMsg,
        updateAccount_errorMsg,
        generateInvoice_errorMsg,

        isFormVisible
    } = props;

    const [alertMsg, setAlertMsg] = useState("");
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);

    function handleError(errorMsg) {
        if (func_validation.isStringTrimNotEmpty(errorMsg) && (!isFormVisible)) {
            setAlertMsg(errorMsg);
            setIsAlertMsgVisible(true);
        }
    }
    useEffect(() => {
        handleError(deleteAccount_errorMsg);
    }, [deleteAccount_errorMsg]);
    useEffect(() => {
        handleError(generateInvoice_errorMsg);
    }, [generateInvoice_errorMsg]);

    let display = (
        <AlertMessage
            message={alertMsg}
            isVisible={isAlertMsgVisible}
            toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
        />
    );

    return [display];
}